import { ChangeEvent, KeyboardEvent } from "react";

export const passwordRex =
  /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,16}$/;

export const checkPassword = (password: string) => {
  return passwordRex.test(password);
};

export const preventString = (e: KeyboardEvent<HTMLInputElement>) => {
  if (["e", "E", "+", "-", ".", " "].includes(e.key)) e.preventDefault();
};

export const inputLength = (e: ChangeEvent<HTMLInputElement>) => {
  if (e.target.value.length > e.target.maxLength)
    e.target.value = e.target.value.slice(0, e.target.maxLength);
};
